<template>
  <div v-if="!regionsWithThumbsData.length" class="mb-48">
    <div class="top-regions-thumbs-placeholders mb-32">
      <div
        v-for="(item, idx) in 4"
        :key="idx"
        class="top-regions-thumbs-placeholders__col"
      >
        <span class="region-thumb-placeholder d-block"></span>
      </div>
    </div>
    <span class="more-collapser-placeholder d-block"></span>
  </div>

  <section v-else class="top-regions-thumbs">
    <splide :slides="regionsWithThumbsData" :options="options">
      <splide-slide v-for="(region, idx) in regionsWithThumbsData" :key="idx">
        <div class="region-thumb">
          <a
            class="region-thumb__link font-18"
            :href="getUrl(region.link)"
            :title="region.nazwa"
          >
            {{ region.nazwa }}
          </a>
          <div class="region-thumb__image">
            <img
              @error="getMainRegionImage(this, region.lokalizacje)"
              @load="hideLoader"
              :src="getThumbImage(region.lokalizacje)"
              :alt="region.nazwa"
            />
            <span class="image-loader">
              <loading-spinner :size="24" />
            </span>
          </div>

          <div class="region-thumb__footer">
            <span class="d-inline-block">Cena od:</span>
            <div class="region-thumb__price">
              <span class="font-m font-22">{{ region.cena }}</span> zł/os.
            </div>
          </div>
        </div>
      </splide-slide>
    </splide>
  </section>
</template>

<script>
import { domainTypeMixin } from "@/mixins/domainTypeMixin";

export default {
  name: "top-regions-thumbnails",
  mixins: [domainTypeMixin],
  props: {
    regionsWithThumbsData: [Array, Object],
  },
  data: () => ({
    regionsImagesPath:
      "https://media.travelone.pl/travelonecdn/images/regions/",
    options: {
      pagination: false,
      perMove: 1,
      perPage: 4,
      breakpoints: {
        991: {
          perPage: 3,
        },
        767: {
          perPage: 2,
        },
        479: {
          perPage: 1,
        },
      },
      gap: "24px",
    },
  }),
  methods: {
    getDomainTypeDirectory() {
      let regionsImagesSubdir;
      if (this.getDomainType("travelone", "")) {
        regionsImagesSubdir = "travelone/";
        return regionsImagesSubdir;
      } else if (this.getDomainType("", "skione")) {
        regionsImagesSubdir = "skione/";
        return regionsImagesSubdir;
      }
    },
    getMainRegionImage(e, locid) {
      let imageLocid = locid.substring(0, 3);

      if (!e) e = window.event;
      let mainRegionImageUrl =
        this.regionsImagesPath +
        this.getDomainTypeDirectory() +
        imageLocid +
        "000001.jpg";
      e.target.src = mainRegionImageUrl;
    },
    getThumbImage(locid) {
      let imageLocid = locid.substring(0, 9);

      return (
        this.regionsImagesPath +
        this.getDomainTypeDirectory() +
        imageLocid +
        ".jpg"
      );
    },
    getUrl(url) {
      if (url.indexOf("www.") != -1) {
        let index = url.indexOf(".pl/");
        let stay = this.getDomainType("travelone", "skione") ? "&pobyt=7" : "";
        return url.substring(index + 3) + stay;
      } else {
        return "https://" + url;
      }
    },
    hideLoader(e) {
      const loaderElem = e.target.nextElementSibling;
      loaderElem.classList.add("_hiding");

      setTimeout(() => {
        loaderElem.remove();
      }, 150);
    },
  },
};
</script>

<style lang="scss" scoped>
.top-regions-thumbs-placeholders {
  display: flex;
  margin-left: -12px;
  margin-right: -12px;
  overflow: hidden;

  &__col {
    flex: 0 0 100%;
    height: 232px;
    padding-left: 12px;
    padding-right: 12px;

    @media (min-width: $screen-xxs) {
      flex: 0 0 50%;
    }

    @media (min-width: $screen-sm) {
      flex: 0 0 percentage(1/3);
    }

    @media (min-width: $screen-md) {
      flex: 0 0 25%;
    }
  }

  .region-thumb-placeholder {
    background-color: $gray-00;
    border: 1px solid $gray-00;
    border-radius: 3px;
    height: 100%;
    overflow: hidden;
    position: relative;

    &::after {
      background-color: #fff;
      content: "";
      display: block;
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 50px;
    }
  }
}

.more-collapser-placeholder {
  background-color: $gray-00;
  border-radius: 2px;
  height: 24px;
  width: 180px;
  margin: 0 auto;
}

.top-regions-thumbs {
  .region-thumb {
    border-radius: 3px 3px 0 0;
    overflow: hidden;
    position: relative;
    margin-bottom: 24px;
    transition: box-shadow ease-in-out 0.12s;
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);

    &:hover {
      @include shadow();
    }

    &__image {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      overflow: hidden;
      position: relative;
      height: 180px;

      > img {
        display: block;
        width: 100%;
        height: auto;
        min-height: 100%;
        object-fit: cover;
        position: absolute;
      }

      &::after {
        background-color: rgba(255, 255, 255, 0);
        background-image: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 45%,
          rgba(6, 6, 37, 0.75) 100%
        );
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
      }
    }

    &__link {
      display: flex;
      align-items: flex-end;
      padding: 12px 12px 64px 12px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 2;

      &,
      &:hover,
      &:focus {
        color: #fff;
        text-decoration: none;
      }
    }

    &__footer {
      border-color: $border-color;
      border-radius: 0 0 3px 3px;
      border-style: solid;
      border-width: 0 1px 1px 1px;
      overflow: hidden;
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      height: 52px;
      padding: 12px;
    }

    &__price {
      color: #eb3e27;
      white-space: nowrap;
    }
  }
}

.top-regions-thumbs ::v-deep {
  .splide__arrow {
    background-color: #fff;
    opacity: 0.85;
    width: 2.25em;
    height: 2.5em;
    top: 35%;

    &:hover {
      opacity: 1;
    }

    &--prev {
      border-radius: 0 2.5em 2.5em 0;
      left: -0.5em;
    }

    &--next {
      border-radius: 2.5em 0 0 2.5em;
      right: -0.5em;
    }

    svg {
      fill: $blue-dark;
    }

    &:disabled {
      display: none;
    }
  }
}

.image-loader {
  background-color: $gray-00;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  transition: opacity 0.2s ease-in-out;

  &._hiding {
    opacity: 0;
  }
}
</style>
